import {
  InjectionToken,
  NgModule,
  Optional,
  signal,
  SkipSelf,
  WritableSignal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FirebaseModule } from './firebase.module';
import { Subject } from 'rxjs';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { User as AuthUser } from 'firebase/auth';
import { Team, User } from '@uploadcam/common';

/**
 * Counter to track number of open dialogs, we need to share this globally as a
 * signal because there might be multiple instances of the dialog service.
 */
export const DIALOG_STACK_SIGNAL = new InjectionToken<WritableSignal<number>>('DialogStackSignal');
export const REFRESH_CREDENTIAL_ERROR$ = new InjectionToken<Subject<void>>(
  'RefreshCredentialError$',
);
export const TEAM_GET_CURRENT$ = new InjectionToken<Subject<Team>>('TeamGetCurrent$');
export const USER_AUTH_STATE_CHANGED$ = new InjectionToken<Subject<AuthUser | undefined>>(
  'UserAuthStateChanged$',
);
export const USER_GET_CURRENT$ = new InjectionToken<Subject<User>>('UserGetCurrent$');

@NgModule({
  imports: [BrowserModule, BrowserAnimationsModule, CommonModule, FirebaseModule],
  providers: [
    {
      provide: DIALOG_STACK_SIGNAL,
      useValue: signal(0),
    },
    {
      provide: REFRESH_CREDENTIAL_ERROR$,
      useValue: new Subject(),
    },
    {
      provide: TEAM_GET_CURRENT$,
      useValue: new Subject(),
    },
    {
      provide: USER_AUTH_STATE_CHANGED$,
      useValue: new Subject(),
    },
    {
      provide: USER_GET_CURRENT$,
      useValue: new Subject(),
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
  ],
})
export class CoreModule {
  // Enforce that CoreModule is only loaded by AppModule, any other
  // module that tries to import this module will error
  // Thanks: https://medium.com/@michelestieven/organizing-angular-applications-f0510761d65a
  constructor(@Optional() @SkipSelf() core: CoreModule) {
    if (core) {
      throw new Error(`CoreModule is already loaded, it only can be imported on AppModule.`);
    }
  }
}
